import clsx from 'clsx';

import type { ModalCommonProps } from './modal-types';
import { ModalStyles } from './modalStyles';

export const ModalFooter = (props: ModalCommonProps) => {
  // Destructuring props
  const { children, content = '', className = '' } = props;

  // Footer content; can be either from content prop or children, but not both
  const footerContent = content || children;

  // Render component
  // **************************************
  return (
    <div className={clsx(ModalStyles.footer, className)}>{footerContent}</div>
  );
};
